import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, MessageCircle } from "lucide-react";
import { CONTACT, waLink } from "../lib/constants";
import GoldDivider from "./GoldDivider";

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-neutral-300 pt-16 pb-8 px-4 md:px-8" data-testid="main-footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="/maxichoix-logo.jpeg" alt="MaxiChoix" className="h-12 w-12 object-contain rounded-full" />
              <span className="font-display text-2xl font-semibold">
                <span className="text-white">MAXI</span>
                <span className="gold-text">CHOIX</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-neutral-400">
              La boutique premium des articles pratiques, utiles et tendance pour toute la famille.
            </p>
          </div>

          <div>
            <h4 className="font-display text-lg text-[#F4E5A1] mb-4">Boutique</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/boutique" className="hover:text-[#F4E5A1] transition">Tous les produits</Link></li>
              <li><Link to="/boutique?category=nouveautes" className="hover:text-[#F4E5A1] transition">Nouveautés</Link></li>
              <li><Link to="/boutique?featured=bestseller" className="hover:text-[#F4E5A1] transition">Meilleures ventes</Link></li>
              <li><Link to="/panier" className="hover:text-[#F4E5A1] transition">Mon panier</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg text-[#F4E5A1] mb-4">Informations</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/a-propos" className="hover:text-[#F4E5A1] transition">À propos</Link></li>
              <li><Link to="/livraison-retours" className="hover:text-[#F4E5A1] transition">Livraison & Retours</Link></li>
              <li><Link to="/faq" className="hover:text-[#F4E5A1] transition">FAQ</Link></li>
              <li><Link to="/mentions-legales" className="hover:text-[#F4E5A1] transition">Mentions légales & CGV</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg text-[#F4E5A1] mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2">
                <Mail size={16} className="text-[#B8860B]" />
                <a href={`mailto:${CONTACT.email}`} className="hover:text-[#F4E5A1] transition break-all">{CONTACT.email}</a>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={16} className="text-[#B8860B]" />
                <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="hover:text-[#F4E5A1] transition">{CONTACT.phoneIntl}</a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin size={16} className="text-[#B8860B]" />
                {CONTACT.city}
              </li>
            </ul>
            <div className="flex gap-3 mt-4">
              <a href={waLink("Bonjour MaxiChoix, j'ai une question.")} target="_blank" rel="noreferrer"
                 className="w-10 h-10 rounded-full border border-[#B8860B]/40 flex items-center justify-center hover:bg-[#B8860B] hover:text-black transition" data-testid="footer-whatsapp">
                <MessageCircle size={18} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer"
                 className="w-10 h-10 rounded-full border border-[#B8860B]/40 flex items-center justify-center hover:bg-[#B8860B] hover:text-black transition">
                <Instagram size={18} />
              </a>
            </div>
          </div>
        </div>

        <GoldDivider className="mb-6" />
        <p className="text-center text-xs text-neutral-500">
          © {new Date().getFullYear()} MaxiChoix — Tous droits réservés. Fait avec soin en Côte d'Ivoire.
        </p>
      </div>
    </footer>
  );
}
